import logoSvg from '../assets/logo-banner.svg';

/**
 * Logo Component
 *
 * Renders the TabPicker logo using the external SVG file with responsive sizing.
 * The logo features a pull-tab design with casino symbols and transparent notch.
 */

interface LogoProps {
  className?: string;
}

export default function Logo({ className = "" }: LogoProps) {
  return (
    <img
      src={logoSvg}
      alt="TabPicker - Pull Tabs Analysis Tool"
      className={className}
    />
  );
}